import script from "./SummaryReportIssue.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportIssue.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportIssue.vue?vue&type=style&index=0&id=cdd3ad28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdd3ad28"]])

export default __exports__